import { AxiosResponse } from 'axios';
import { Key } from 'react';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { LocationDTO, LocationNodeDTO } from './dto';
import { GetManyPaged, GetManyUnpaged, GetOne } from './types';

const RESOURCE_PATH = 'locations';

export type LocationWithNodeDTO = LocationDTO & { node: LocationNodeDTO };

export const getLocation: GetOne<{ id: string }, LocationDTO> = async ({ id, config }) =>
    client.get(buildPath([RESOURCE_PATH, id]), config).then((response) => response.data);

export const getLocations: GetManyPaged<LocationDTO> = async ({ filter, page, size, sort, config } = {}) =>
    client
        .get(buildPath([RESOURCE_PATH]), { ...config, params: { filter, page, size, sort } })
        .then((response: AxiosResponse) => response.data);

export const getLocationsByName: GetManyUnpaged<
    { query: string; onlySelectable: boolean | undefined; facilityCode: string | undefined },
    LocationDTO
> = async ({ query, onlySelectable, facilityCode, config }) =>
    client
        .get(buildPath([RESOURCE_PATH, 'selectable']), { ...config, params: { query, onlySelectable, facilityCode } })
        .then((response: AxiosResponse) => response.data);

export const getLocationRoots: GetManyUnpaged<
    { ids: Key[] | undefined; facilityCode: string | undefined },
    LocationWithNodeDTO
> = async ({ ids, facilityCode, config }) => {
    const path = facilityCode ? [RESOURCE_PATH, 'roots', facilityCode] : [RESOURCE_PATH, 'roots'];
    return client.get(buildPath(path), { ...config, params: { ids } }).then((response: AxiosResponse) => response.data);
};

export const getLocationChildren: GetManyUnpaged<{ parent: LocationWithNodeDTO }, LocationWithNodeDTO> = async ({
    parent,
}) => client.get(buildPath([RESOURCE_PATH, parent.id, 'children'])).then((response: AxiosResponse) => response.data);

export const isDescendantOfProvidedLocations: GetOne<
    { location: LocationDTO; locationsList: LocationDTO[] },
    boolean
> = async ({ location, locationsList, config }) =>
    client
        .post(buildPath([RESOURCE_PATH, location.id, 'isDescendant']), locationsList, config)
        .then((response: AxiosResponse) => response.data);
